export const leagues = [
  'mlb',
  'nba',
  'nfl',
  'nhl',
  'ncaa-mens-football',
  'ncaa-mens-basketball',
  'mls-major-league-soccer',
  'wnba',
  'tennis',
  'wwe',
  'pwhl',
  'cfl',
  'rodeo',
  'world-cup',
  'super-bowl',
  'pro-bowl',
  'english-premier-league',
  'la-liga',
  'italian-serie-a',
  'bundesliga',
  'ligue-1',
];

export const eventTypes = [
  'concerts',
  'sports',
  'baseball',
  'basketball',
  'hockey',
  'football',
  'nhl',
  'soccer',
  'pga',
  'formula-1',
  'nascar',
  'ufc',
  'wnba',
  'tennis',
  'wwe',
  'pwhl',
  'cfl',
  'rodeo',
  'world-cup',
  'super-bowl',
  'pro-bowl',
  'english-premier-league',
  'la-liga',
  'italian-serie-a',
  'bundesliga',
  'ligue-1',
];

export const sports = [
  'pga',
  'formula-1',
  'nascar',
  'ufc',
  'wnba',
  'tennis',
  'wwe',
  'pwhl',
  'cfl',
  'rodeo',
  'world-cup',
  'super-bowl',
  'pro-bowl',
];

export const labels = {
  mlb: 'MLB',
  nba: 'NBA',
  nfl: 'NFL',
  nhl: 'NHL',
  mls: 'MLS',
  pga: 'PGA Tour',
  'formula-1': 'Formula 1',
  nascar: 'Nascar',
  ufc: 'UFC',
  'ncaa-mens-football': 'NCAA Football',
  'ncaa-mens-basketball': 'NCAA Basketball',
  wnba: 'WNBA',
  tennis: 'Tennis',
  wwe: 'WWE',
  pwhl: 'PWHL',
  cfl: 'CFL',
  rodeo: 'Rodeo',
  'world-cup': 'World Cup',
  'super-bowl': 'Super Bowl',
  'pro-bowl': 'Pro Bowl',
};

export const popular = ['mlb', 'nba', 'nfl', 'nhl'];

export const tevoSlugs = {
  'ncaa-mens-basketball': 'ncaa-men--2',
  'ncaa-mens-football': 'ncaa--2',
  ufc: 'mixed-martial-arts-mma',
  mlb: 'mlb',
  'mlb-spring-training': 'mlb-spring-training',
  nba: 'nba',
  nfl: 'nfl',
  nhl: 'nhl',
  mls: 'mls-major-league-soccer',
  pga: 'pga',
  'formula-1': 'formula-1',
  nascar: 'nascar',
  wnba: 'wnba',
  tennis: 'tennis',
  wwe: 'wwe',
  pwhl: 'pwhl',
  cfl: 'cfl',
  rodeo: 'rodeo',
  'world-cup': 'world-cup',
  'super-bowl': 'super-bowl',
  'pro-bowl': 'pro-bowl',
  'premier-league': 'english-premier-league',
  'la-liga': 'la-liga',
  'serie-a': 'italian-serie-a',
  bundesliga: 'bundesliga',
  'ligue-1': 'ligue-1',
};

// NCAA league identifiers can arrive either as legacy API codes ('NCAAB'/'NCAAF')
// or as URL slugs ('ncaa-mens-basketball'/'ncaa-mens-football').
export const apiToUrlSlug: Record<string, string> = {
  ncaab: 'ncaa-mens-basketball',
  ncaaf: 'ncaa-mens-football',
};

export const urlSlugToApi: Record<string, string> = {
  'ncaa-mens-basketball': 'ncaab',
  'ncaa-mens-football': 'ncaaf',
};

// Helper to get API code from URL slug
export const getApiLeagueCode = (urlSlug: string): string => {
  const normalized = urlSlug?.toLowerCase() || '';
  return urlSlugToApi[normalized] || normalized;
};

// Helper to get URL slug from API code
export const getUrlSlugFromApi = (apiCode: string): string => {
  const normalized = apiCode?.toLowerCase() || '';
  return apiToUrlSlug[normalized] || normalized;
};

export const getComparableLeagueCodes = (leagueCode: string): string[] => {
  const normalized = leagueCode?.toLowerCase() || '';

  return Array.from(
    new Set([
      normalized,
      getApiLeagueCode(normalized),
      getUrlSlugFromApi(normalized),
    ])
  );
};

// Legacy TEVO slug to URL slug mappings for redirects
export const tevoToUrlSlug: Record<string, string> = {
  'ncaa--2': 'ncaa-mens-football',
  'ncaa-men--2': 'ncaa-mens-basketball',
};
